import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import * as listActions from '../codesList/actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';
import store from '../../../store';

function* deactivateCodeBulk({ payload: { codes, type, onSuccess } }) {
  const { getState, dispatch } = store;

  try {
    const { data } = yield call(fetch, { api: api.codes.bulk_deactivate, data: { codes } });

    dispatch(listActions.getCodesRequest({ type, curr_page: getState().getCodes.curr_page, filters: getState().getCodes.filters }));

    onSuccess && onSuccess();
    yield put(actions.deactivateCodeBulkDone(data.results));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.deactivateCodeBulkFailed,
      endpoint: api.codes.bulk_deactivate.url
    });
  }
}

export const deactivateCodeBulkSaga = takeEvery(types.DEACTIVATE_CODE_BULK_REQUEST, deactivateCodeBulk);